import { render, staticRenderFns } from "./distributionSummaryTable.vue?vue&type=template&id=55e329cd&scoped=true"
import script from "./distributionSummaryTable.vue?vue&type=script&lang=js"
export * from "./distributionSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./distributionSummaryTable.vue?vue&type=style&index=0&id=55e329cd&prod&scoped=true&lang=css"
import style1 from "./distributionSummaryTable.vue?vue&type=style&index=1&id=55e329cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e329cd",
  null
  
)

export default component.exports